/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FeedbackCreateFeedbackParam model module.
 * @module model/FeedbackCreateFeedbackParam
 * @version 1.0
 */
class FeedbackCreateFeedbackParam {
    /**
     * Constructs a new <code>FeedbackCreateFeedbackParam</code>.
     * @alias module:model/FeedbackCreateFeedbackParam
     */
    constructor() { 
        
        FeedbackCreateFeedbackParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FeedbackCreateFeedbackParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FeedbackCreateFeedbackParam} obj Optional instance to populate.
     * @return {module:model/FeedbackCreateFeedbackParam} The populated <code>FeedbackCreateFeedbackParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FeedbackCreateFeedbackParam();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} message
 */
FeedbackCreateFeedbackParam.prototype['message'] = undefined;

/**
 * @member {String} name
 */
FeedbackCreateFeedbackParam.prototype['name'] = undefined;

/**
 * @member {Number} userId
 */
FeedbackCreateFeedbackParam.prototype['userId'] = undefined;






export default FeedbackCreateFeedbackParam;

